/**
 * 화면 구현
 */
import { SbsPlayerGlobal } from '../../common';

import './app';
import './back';
import './buy';
import './pass';
import './text';
import './unmute';
import './login';

customElements.define(
  'sbs-player-toparea',
  class extends HTMLElement {
    constructor() {
      super();

      this.text = null;
    }

    static get observedAttributes() {
      return [];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        if (SbsPlayerGlobal.target === 'golf') return false;
        if (window.location.hostname.indexOf('.golf.') > -1) return false;

        const { info } = SbsPlayerGlobal.state.data;

        if (info === undefined) return false;
        // - VOD 1분 미리보기	초고화질 1분 미리보기 중입니다.
        // - LIVE(m) 라이브 모바일 1분 미리보기	모바일 웹에서는 1분 미리보기만 제공됩니다.
        // - LIVE(pc) 라이브 1분 미리보기	라이브 1분 미리보기 중입니다.로그인 후 일반화질로 무료 시청하세요.

        if (info.preview_yn === 'Y' || info.type === 'VOD3MIN') {
          if (SbsPlayerGlobal.state.is_mobile) {
            this.text = 'SBS play 앱에서 VOD를 시청하세요.';
          } else {
            this.text = '이용권 구매 후 시청 가능한 콘텐츠 입니다.';
          }
        } else if (info.onair_preview_yn === 'Y') {
          if (SbsPlayerGlobal.state.is_mobile) {
            this.text = 'SBS play 앱에서 무료로 시청하세요.';
          } else {
            this.text = '로그인 후 실시간 라이브를 무료로 시청하세요.';
          }
        }

        this.innerHTML = `<div class="${
          info.preview_yn === 'Y' ||
          info.type === 'VOD3MIN' ||
          info.onair_preview_yn === 'Y'
            ? 'playerTopArea_preview'
            : 'playerTopArea_w'
        }">
                      <div class="playerTopArea-left">
                        ${
                          SbsPlayerGlobal.vodtype.indexOf('ALLVOD') > -1
                            ? `<sbs-player-toparea-back></sbs-player-toparea-back>`
                            : ``
                        }
                        ${
                          this.text
                            ? `<sbs-player-toparea-text text="${this.text}"></sbs-player-toparea-text>`
                            : ``
                        }
                        <sbs-player-toparea-unmute></sbs-player-toparea-unmute>
                      </div>
                      <div class="playerTopArea-right">
                        ${
                          SbsPlayerGlobal.state.is_mobile
                            ? `<sbs-player-toparea-app></sbs-player-toparea-app>`
                            : ``
                        }
                        ${
                          info.preview_yn === 'Y' &&
                          !SbsPlayerGlobal.state.is_mobile
                            ? `<sbs-player-toparea-pass></sbs-player-toparea-pass>`
                            : ``
                        }
                        ${
                          info.onair_preview_yn === 'Y' &&
                          !SbsPlayerGlobal.state.is_mobile
                            ? `<sbs-player-toparea-login></sbs-player-toparea-login>`
                            : ``
                        }
                      </div>
                    </div>`;
        this.event();
        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      try {
        if (!this.text) {
          // * hide_controls
          SbsPlayerGlobal.events.addEventListener(
            'controller-hide-event',
            (hidden) => {
              const hideControls = this.querySelector('.playerTopArea_w');
              hidden
                ? hideControls.classList.add('hide_controls')
                : hideControls.classList.remove('hide_controls');
            }
          );
        }

        this.querySelector('sbs-player-toparea-buy')?.addEventListener(
          'billing-popup',
          (event) => {
            this.dispatchEvent(
              new CustomEvent('billing-popup', {
                detail: event.detail,
              })
            );
          }
        );
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
        this.innerHTML += `<style>
        .playerADType .playerTopArea-right {
          display: none !important;
        }
        .playerTopArea_w {
          z-index: 10 !important;
        }
        .playerTopArea_preview {
          z-index: 10 !important;
        }
      </style>`;
      } catch (error) {
        console.error(error);
      }
    }
  }
);
